import {
  VERIFY_SUCCESS,
  VERIFY_FAILURE,
  VARIFY_IMAGE_SUCCESS,
  VARIFY_IMAGE_FAILURE,
} from '../actions/types'

const initialState = {
  passportId: '',
  imagePassportId: '',
  level: [],
  category: [],
  responseStatus: '',
  fileName: '',
}

const verify = (state = initialState, action) => {
  switch (action.type) {
    case VERIFY_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }
    case VERIFY_FAILURE:
      return {
        ...state,
        ...action.payload,
      }
    case VARIFY_IMAGE_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }
    case VARIFY_IMAGE_FAILURE:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}

export default verify



// WEBPACK FOOTER //
// ./src/reducers/verify.js